import { Button } from "./ui/button";
import { ShareBar } from "./ShareBar";

export const Footer = ({ onBook }) => (
  <footer data-testid="footer" className="bg-brand-ink text-brand-cream">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <ShareBar />
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <p className="font-serif text-4xl sm:text-5xl font-light leading-tight mb-6 max-w-lg">
            Your parents deserve to feel remembered.
          </p>
          <Button
            data-testid="footer-book-btn"
            onClick={onBook}
            className="rounded-full bg-brand hover:bg-brand-hover text-white px-8 h-13 py-3"
          >
            Request a home visit
          </Button>
        </div>
        <div className="lg:col-span-6 grid grid-cols-2 gap-8 text-sm">
          <div className="space-y-3">
            <p className="text-brand-cream/40 uppercase tracking-widest text-xs mb-4">
              Explore
            </p>
            <FooterLink href="#services">Services</FooterLink>
            <FooterLink href="#hospitals">Hospitals</FooterLink>
            <FooterLink href="#how">How it works</FooterLink>
            <FooterLink href="#manifesto">Our promise</FooterLink>
            <FooterLink href="#faq">FAQ</FooterLink>
            <FooterLink href="#contact">Contact</FooterLink>
            <FooterLink href="/report">Representative portal</FooterLink>
            <FooterLink href="/team">Team inbox</FooterLink>
          </div>
          <div className="space-y-3">
            <p className="text-brand-cream/40 uppercase tracking-widest text-xs mb-4">
              Reach us
            </p>
            <p className="text-brand-cream/70">Phone: coming soon</p>
            <p className="text-brand-cream/70">WhatsApp: coming soon</p>
            <p className="text-brand-cream/70">cceldercare24@gmail.com</p>
            <p className="text-brand-cream/70">Jaipur, Rajasthan</p>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-brand-cream/50">
        <span className="font-serif text-lg text-brand-cream">
          Eldercare<span className="text-brand-gold">24</span>
        </span>
        <span>© {new Date().getFullYear()} Eldercare24 · Made with care in Jaipur</span>
      </div>
    </div>
  </footer>
);

const FooterLink = ({ href, children }) => (
  <a
    href={href}
    className="block text-brand-cream/70 hover:text-brand-gold transition-colors"
  >
    {children}
  </a>
);
